import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { colors } from '../../styles/variables';

const Card = styled.div`
  background-color: ${colors.white};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  height: 100%;
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.1);
  }
`;

const CourseImage = styled.div`
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${props => props.bgColor || colors.secondary};
  background-image: ${props => props.bgImage ? `url(${props.bgImage})` : 'none'};

  @media (max-width: 768px) {
    height: 260px;
    background-position: center;
  }

  @media (max-width: 480px) {
    height: 230px;
  }
`;

const CourseContent = styled.div`
  padding: 26px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const CourseTag = styled.span`
  display: inline-block;
  background-color: rgba(0, 196, 113, 0.1);
  color: ${colors.secondary};
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 16px;
`;

const CourseTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
  color: ${colors.primary};
`;

const CourseDescription = styled.p`
  font-size: 16px;
  color: ${colors.textGray};
  margin-bottom: 24px;
  min-height: 112px;
  line-height: 1.65;
  overflow: hidden;
`;

const CourseFeatures = styled.div`
  margin-bottom: 24px;
`;

const Feature = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const FeatureIcon = styled.div`
  width: 20px;
  height: 20px;
  background-color: rgba(0, 196, 113, 0.1);
  color: ${colors.secondary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  font-size: 12px;
`;

const FeatureText = styled.div`
  font-size: 14px;
  color: ${colors.tertiary};
`;

const CourseButton = styled(Link)`
  display: block;
  text-align: center;
  background-color: ${colors.white};
  color: ${colors.secondary};
  border: 1px solid ${colors.secondary};
  padding: 12px;
  border-radius: 4px;
  font-weight: 500;
  text-decoration: none;
  transition: background-color 0.2s, color 0.2s;
  margin-top: auto;
  
  &:hover {
    background-color: ${colors.secondary};
    color: ${colors.white};
  }
`;

const CourseCard = ({ 
  tag, 
  title, 
  description, 
  features, 
  imageClass, 
  bgColor, 
  bgImage, 
  link 
}) => {
  return (
    <Card>
      <Link to={link} style={{ textDecoration: 'none' }}>
        <CourseImage 
          className={imageClass} 
          bgColor={bgColor} 
          bgImage={bgImage} 
          imageClass={imageClass}
        />
      </Link>
      <CourseContent>
        <CourseTag>{tag}</CourseTag>
        <CourseTitle>{title}</CourseTitle>
        <CourseDescription>{description}</CourseDescription>
        <CourseFeatures>
          {features.map((feature, index) => (
            <Feature key={index}>
              <FeatureIcon>✓</FeatureIcon>
              <FeatureText>{feature}</FeatureText>
            </Feature>
          ))}
        </CourseFeatures>
        <CourseButton to={link}>자세히 보기</CourseButton>
      </CourseContent>
    </Card>
  );
};

export default CourseCard;
